import React, { Component } from 'react';
import styled from '@emotion/styled';
import onClickOutside from 'react-onclickoutside';
import { Theme } from 'ui_system/theme';
import { colors } from 'ui_system/compass/utils';

const DropdownBox = styled.div`
  position: ${(props) =>
    props.forgog && !props.customdropdown ? 'fixed' : 'absolute'};
  top: ${(props) =>
    props.forgog && !props.customdropdown ? props.topValue : '100%'};
  width: ${(props) => (props.forgog && !props.customdropdown ? '78%' : '100%')};
  left: ${(props) => (props.forgog && !props.customdropdown ? '11%' : '0px')};
  background: white;
  display: ${(props) => (props.open ? 'block' : 'none')};
  border: ${(props) => (props.empty ? 'none' : '1px solid #888ca5')};

  font-size: 14px;
  color: ${Theme.colors.black};
  border-top: ${(props) => (props.topborder ? null : '0px')};
  max-height: 300px;
  overflow-y: auto;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    position: absolute;
    width: 100%;
    top: 100%;
    left: 0;
    border: 1px solid ${colors.borderAction};
`;

class Dropdown extends Component {
  handleClickOutside() {
    const { open, setOpen } = this.props;

    if (open) {
      setOpen(false);
    }
  }

  render() {
    const { open, items, forgog, customdropdown, topValue } = this.props;

    return (
      <DropdownBox
        data-testid="dropdown-box"
        empty={!items || items.length === 0}
        open={open}
        forgog={forgog}
        customdropdown={customdropdown}
        topValue={topValue}
      >
        {items}
      </DropdownBox>
    );
  }
}
export default onClickOutside(Dropdown);
